import { computed } from 'vue'
import { useSeasonalTheme } from '~/composables/ui/useSeasonalTheme'

/** Marge bas pour dégager le décor `body::*-theme::after` (coin bas-droit), voir `_seasonal.scss` (≥768px). */
const SEASONAL_CORNER_EXTRA_BOTTOM_PX = 96

/**
 * Décalage bas (px) à appliquer aux éléments fixes bas-droite (toasts, toolbox)
 * quand un événement saisonnier affiche la déco d’angle.
 */
export function useSeasonalCornerBottomInsetPx() {
  const { isSeasonActive, decorPrefs } = useSeasonalTheme()

  return computed(() => {
    if (!import.meta.client) {
      return 0
    }
    if (!isSeasonActive.value || !decorPrefs.value.corner) {
      return 0
    }
    if (!window.matchMedia('(min-width: 768px)').matches) {
      return 0
    }
    return SEASONAL_CORNER_EXTRA_BOTTOM_PX
  })
}
